import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronDown, ChevronRight, Menu, X } from 'lucide-react';
import './Dashboard.css';

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [pagesExpanded, setPagesExpanded] = useState(true);
  const [activeSection, setActiveSection] = useState('Dashboard');

  const navigationConfig = {
    mainItems: [
      {
        name: 'Dashboard',
        path: '/dashboard',
        icon: 'dashboard-icon'
      },
      {
        name: 'Inquiry',
        path: '/inquiry',
        icon: 'inquiry-icon'
      }
    ],
    pagesItems: [
      {
        name: 'Carousel',
        path: '/DCarousel'
      },
      {
        name: 'About Us',
        path: '/DAboutus'
      },
      {
        name: 'Our Services',
        path: '/DOurservices'
      },
      {
        name: 'Our Team',
        path: '/DOurservices'
      },
      {
        name: 'Why Choose Us',
        path: '/DWhychoose'
      }
     
    ]
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const togglePages = () => {
    setPagesExpanded(!pagesExpanded);
  };

  const handleSectionClick = (section, path) => {
    setActiveSection(section);
    navigate(path);
    if (window.innerWidth < 768) {
      setSidebarOpen(false);
    }
  };

  const isActiveItem = (itemPath) => {
    return currentPath === itemPath;
  };

  return (
    <div className="dashboard-container">
      {/* Sidebar */}
      <div className={`sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <div className="logo">
            <div className="logo-icon">
              <div className="logo-squares">
                <div className="square"></div>
                <div className="square"></div>
                <div className="square"></div>
                <div className="square"></div>
              </div>
            </div>
            <span className="logo-text">Pecunia Dashboard</span>
          </div>
        </div>

        <nav className="sidebar-nav">
          {/* Main Navigation Items */}
          {navigationConfig.mainItems.map((item, index) => (
            <div
              key={index}
              className={`nav-item ${isActiveItem(item.path) ? 'active' : ''}`}
              onClick={() => handleSectionClick(item.name, item.path)}
            >
              <div className={`nav-icon ${item.icon}`}></div>
              <span className="nav-text">{item.name}</span>
              <span className="nav-path">{item.path}</span>
            </div>
          ))}

          {/* Pages Section */}
          <div className="nav-item pages-item">
            <div className="nav-item-header" onClick={togglePages}>
              <div className="nav-icon pages-icon"></div>
              <span className="nav-text">Pages</span>
              <div className="nav-chevron">
                {pagesExpanded ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
              </div>
            </div>

            {pagesExpanded && (
              <div className="sub-items">
                {navigationConfig.pagesItems.map((item, index) => (
                  <div
                    key={index}
                    className={`sub-item ${isActiveItem(item.path) ? 'active' : ''}`}
                    onClick={() => handleSectionClick(item.name, item.path)}
                  >
                    <span className="sub-item-text">{item.name}</span>
                    <span className="sub-item-path">{item.path}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </nav>
      </div>

      {/* Main Content */}
      <div className="main-content2">
        {/* Header */}
        <header className="header">
          <div className="header-left">
            <button className="mobile-menu-btn" onClick={toggleSidebar}>
              {sidebarOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
            <h1 className="page-title">Pecunia Dashboard</h1>
          </div>

          <div className="header-right">
            <button className="sign-in-btn">Sign In</button>
          </div>
        </header>

        {/* Dashboard Content */}
        <div className="dashboard-content">
          <div className="content-placeholder">
            <h2 className="content-title">Welcome to {activeSection}</h2>
            <p className="content-description">
              Content for {activeSection} section will be displayed here.
            </p>
            <div className="current-path-display">
              <strong>Current Path:</strong>
              <code className="path-code">{currentPath}</code>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={toggleSidebar}></div>
      )}
    </div>
  );
};

export default Dashboard;
